import React from 'react'

const Spinner = () => (
  <div className="sk-wave">
    <div className="sk-rect sk-rect1" />
    <div className="sk-rect sk-rect2" />
    <div className="sk-rect sk-rect3" />
    <div className="sk-rect sk-rect4" />
    <div className="sk-rect sk-rect5" />
  </div>
)

export { Spinner as default }



/** WEBPACK FOOTER **
 ** ./src/Spinner.js
 **/